<template>
    <div>
        <h2 class="mb-0">
            <fa-icon
                :icon="['fa','barcode']"
                class="mr-2"
            /> Auth Code
        </h2>

        <div>
            Introduce el código que hemos enviado a tu email junto con tu nueva contraseña
        </div>

        <div class="py-4" />

        <validation-observer v-slot="{ passes, invalid }">
            <form
                class="mb-4"
                @submit.prevent="passes(setPassword)"
            >
                <div class="row">
                    <div class="col-12 text-left">
                        <validation-provider
                            v-slot="slotProps"
                            rules="required"
                        >
                            <a-form-item
                                class="mb-2"
                                :validate-status="$helpers.validateStatus(slotProps)"
                                :help="slotProps.errors[0]"
                            >
                                <a-input
                                    v-model="code"
                                    size="large"
                                    placeholder="Código de autorización"
                                >
                                    <fa-icon
                                        slot="prefix"
                                        class="pr-1"
                                        :icon="['fa','barcode']"
                                    />
                                </a-input>
                            </a-form-item>
                        </validation-provider>

                        <validation-provider
                            v-slot="slotProps"
                            :rules="'required|_userPassword|password:@confirm'"
                        >
                            <a-form-item
                                has-feedback
                                :validate-status="$helpers.validateStatus(slotProps)"
                                :help="slotProps.errors[0]"
                                class="mb-2"
                            >
                                <a-input
                                    v-model="password"
                                    size="large"
                                    placeholder="Nueva contraseña"
                                    type="password"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="lock"
                                    />
                                </a-input>
                            </a-form-item>
                        </validation-provider>

                        <validation-provider
                            v-slot="slotProps"
                            name="confirm"
                            :rules="'required'"
                        >
                            <a-form-item
                                has-feedback
                                :validate-status="$helpers.validateStatus(slotProps)"
                                :help="slotProps.errors[0]"
                            >
                                <a-input
                                    v-model="password2"
                                    size="large"
                                    placeholder="Confirmar nueva contraseña"
                                    type="password"
                                >
                                    <a-icon
                                        slot="prefix"
                                        type="lock"
                                    />
                                </a-input>
                            </a-form-item>
                        </validation-provider>
                    </div>
                </div>

                <a-button
                    class="text-center btn btn-success w-100 font-weight-bold font-size-18"
                    type="primary"
                    html-type="submit"
                    :disabled="invalid"
                    size="large"
                >
                    Modificar
                </a-button>
            </form>
        </validation-observer>

        <a @click="$emit('back')">
            <fa-icon :icon="['fa','arrow-left']" /> Atrás
        </a>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            code: '',
            password: '',
            password2: ''
        };
    },
    methods: {
        async setPassword() {
            this.$nprogress.start();
            this.loading = true;

            const restore = await this.$gestios.auth.restore({
                email: this.value,
                password: this.password,
                authcode: this.code
            });

            if (restore.ok) {
                this.$toast.success('Tu contraseña fue modificada correctamente. Ahora puedes iniciar sesión');
                this.$router.push({ name: '_login' });
            } else {
                this.$toast.error('Los datos introducidos no son correctos');
            }

            this.$nprogress.done();
            this.loading = false;
        }
    }
};
</script>

<style scoped>
</style>
